import React, { useCallback, useContext, useRef } from 'react';
import { Handle, NodeProps, Position } from 'reactflow';
import BotBuilderNode from '../BotBuilderNode/BotBuilderNode';
import BotResponseTreeNode from '../../../../types/BotBuilder/BotResponseTreeNode';
import BotBuilderContext from '../../../../context/BotBuilderContext/BotBuilderContext';

export type DoNothingNodeData = {
  node: BotResponseTreeNode;
  isLocked?: boolean;
};

function DoNothingNode(
  props: NodeProps<DoNothingNodeData>
): React.ReactElement {
  const { data, isConnectable, id } = props;
  const { onNodeDelete } = useContext(BotBuilderContext);
  const deleteButtonRef = useRef<HTMLButtonElement>(null);

  const handleDelete = useCallback(async () => {
    onNodeDelete(data.node);
  }, [data.node, onNodeDelete]);

  return (
    <BotBuilderNode
      title='Do nothing'
      deleteButtonRef={deleteButtonRef}
      onNodeDelete={handleDelete}
      sourceNode={data.node}
      showAddButton={false}
      isLocked={data.isLocked}
    >
      <Handle
        type='target'
        position={Position.Top}
        style={{ top: -10 }}
        id={id}
        isConnectable={isConnectable}
      />
    </BotBuilderNode>
  );
}

export default DoNothingNode;
